<script>
    export let item
    export let status
    export let active

    $: if(active) {
        //console.log('loading email')
    } else {
        //console.log('unloading email')
    }

</script>

<form class="ui form">
    <h4 class="ui header">Envio de Email</h4>
    <div class="disabled field">
        <label>Para:</label>
        <input type="text" value="joao@empresa.com">
    </div>
    <div class="field">
        <label>Assunto:</label>
        <input type="text" value="Dúvidas Pedido {item.inquiry.protocol}">
    </div>
    <div class="field">
        <label>Mensagem</label>
        <textarea rows="2"></textarea>
    </div>            
    <div class="ui button" tabindex="0">Enviar</div>
</form>
